import LightningIcon from '../../../../../../../assets/svgs/Lightning'
import NewsItem from './NewsItem'
import style from './style.module.css'

const NewsBlock = () => {
  return (
    <div className={style.companyModal_news}>
      <div className={style.companyModal_news_title}>
        <LightningIcon />
        <span>Hot News</span>
      </div>

      <div className={style.companyModal_news_list}>
        <NewsItem />
        <NewsItem />
        <NewsItem />
      </div>

      <div className={style.companyModal_news_scrollText}>
        <span>scroll to see more</span>
      </div>
    </div>
  )
}

export default NewsBlock
